export default {
  to: "/license/license-list",
  order: 3,
  icon: "mdi-certificate",
  title: "License Applications",
  sublinks: [
    {
      to: `/dashboard/license/reports`,
      order: 1,
      title: "Executive Dashboard",
      disabled: false,
      icon: "mdi-monitor-dashboard",
    },
    {
      to: `/dashboard/license/list`,
      order: 2,
      title: "My License",
      disabled: false,
      icon: "mdi-clipboard-list-outline",
    },
  ],
};
